import axios from 'axios';
import { GOOGLE_MAPS_API } from '../../environment_variable';
import { SupportedCities } from './Constants';
import { ENDPOINTS, AWS_API_REQUEST, LOCAL_API_REQUEST } from '../../configurations';

export const translateCityName = (cityName) => {
  // Define translations for specific city names
  const cityTranslations = {
    "Montréal": "Montreal",
    // Add more translations as needed
  };

  // If the cityName exists in translations, return the translated name, otherwise return the original name
  return cityTranslations[cityName] || cityName;
};

export const handleAddressToGeolocation = async (address, setDestinationCoords, toast) => {
  //console.log('Attempt to convert address to geolocation')
  const URL = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${GOOGLE_MAPS_API}`;

  try {
    const response = await axios.get(URL);
    const responseData = response.data;

    if (responseData.results[0]) {
      const { lat, lng } = responseData.results[0].geometry.location;

      // Find the locality component which should contain the city name
      const cityComponent = responseData.results[0].address_components.find(component => component.types.includes('locality'));
    
      // If locality component found, use its long_name as the city, otherwise, fallback to empty string
      let city = cityComponent ? cityComponent.long_name : '';
    
      // Translate the city name if needed
      city = translateCityName(city);

      setDestinationCoords({lat: lat, lng: lng});

      return { latitude: lat, longitude: lng, city: city }; // Return as an object
    } else {
      console.error("Invalid address provided. Please enter a valid address.");
      toast.error("Please enter a valid address.");
      return { latitude: -1, longitude: -1, city: '' }; // Return -1 for latitude and longitude if address is invalid
    }

  } catch (error) {
    // Handle errors
    console.error('Error fetching data:', error);
    toast.error("Invalid address provided. Please enter a valid address.");
    return { latitude: -1, longitude: -1, city: '' }; // Return -1 for latitude and longitude in case of an error
  }
}

export const isCitySupported = (city, supportedCity) => city === supportedCity;

export const getNearbyParkingUrl = ({ latitude, longitude, city, searchRange, database, arrivalDateTime, vehicleType, state }) => {

  // TODO: when cloud is ready
  // let url = (city === SupportedCities.MONTREAL ? AWS_API_REQUEST : LOCAL_API_REQUEST) +
  //   ENDPOINTS.GET_NEARBY_PARKING_SIGN_ZONE +
  //   `?latitude=${latitude}&longitude=${longitude}&searchRange=${searchRange}&database=${database}&arrivalDatetime=${arrivalDateTime}&vehicleType=${vehicleType}&state=${state}`;

  // if (city === SupportedCities.BELLEVUE) {
  //   url += `&city=${city}`;
  // }

  let url = LOCAL_API_REQUEST +
    ENDPOINTS.GET_NEARBY_PARKING_SIGN_ZONE +
    `?latitude=${latitude}&longitude=${longitude}&searchRange=${searchRange}&database=${database}&arrivalDatetime=${arrivalDateTime}&vehicleType=${vehicleType}&state=${state}`;


  return url;
};

